<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>
        <items-view
          store-module="invoices" @items="items = $event" @state="state = $event"
          storeModule="invoices"
          titleSingle="Invoice"
          titleMultiple="Invoices"
          :headers="headers"
          :itemsMap="itemsMap"
          :itemsFilter="itemsFilter"
          defaultSort="serialNumber"
          defaultSortDesc
          :rightAlignButtons="false"
          :saveEnabled="true"
          :deleteEnabled="false"
          :createEnabled="false"
          :editItemId="invoiceId"
        >

          <template #before-search="{items}">
            <v-checkbox
              label="Hide collected invoices"
              v-model="hideCollectedInvoices"
            ></v-checkbox>

            <p class="body-1">
              {{items.length}} invoices with a total current amount of {{items.reduce((a, item) => a + item.amount, 0)}} SEK
            </p>
          </template>

          <template #item.serialNumber="{item}">
            <span>{{item.serialNumber}}</span>
          </template>
          <template #item.amount="{item}">
            <span :class="{'text--disabled': item.amount == 0}">{{item.amount}} SEK</span>
          </template>
          <template #item.companyName="{item}">
            <span>{{item.companyName.slice(0,55)}}</span>
          </template>
          <template #item.dateCreated="{item}">
            <span>{{moment(item.dateCreated).tz('Europe/Stockholm').format('YYYY DD MMM HH:mm')}}</span>
          </template>

          <template #itemForm="slotProps">
            <invoice-form v-bind="slotProps" />
          </template>
        </items-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ItemsView} from 'dync-baseitem';
import InvoiceForm from '../components/InvoiceForm.vue';
import moment from 'moment-timezone'

export default {
  name: 'Invoices',
  props: {
    invoiceId: {}
  },
  data() {
    return {
      hideCollectedInvoices: true,
      moment,
      headers: [
        {
          text: 'Serial Number',
          value: 'serialNumber'
        },
        {
          text: 'Amount',
          value: 'amount'
        },
        {
          text: 'Company',
          value: 'companyName'
        },
        {
          text: 'status',
          value: 'status'
        },
        {
          text: 'Created at',
          value: 'dateCreated'
        }
      ]
    };
  },
  computed: {
    itemsFilter() {
      if (this.hideCollectedInvoices) {
        return {
          keyValue: [
            ['status', 'CREATED']
          ]
        }
      }
      return null;
    }
  },
  methods: {
    itemsMap(item) {
      item = {...item};
      return item;
    }
  },
  components: {
    ItemsView,
    InvoiceForm
  }
}
</script>

<style lang="scss" scoped>
</style>
